import {
  createContext, useContext, useMemo, type PropsWithChildren,
} from 'react';

import { useCart } from './useCart';

export type CartContextValue = ReturnType<typeof useCart>;

const CartContext = createContext<CartContextValue | null>(null);

// Here we can create a single instance of useCart and use it across the app
export function CartProvider({ children }: PropsWithChildren) {
  const cart = useCart();

  const value = useMemo(
    () => cart,
    [cart],
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export function useCartContext(): CartContextValue {
  const value = useContext(CartContext);
  if (value == null) {
    throw new Error('useCartContext must be used within a CartProvider');
  }
  return value;
}
